module.exports = __webpack_public_path__ + "assets/img/effect_(6).5735c1da.gif";